import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHighestKodemScore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.10432 7.85416L2.5512 12.983C2.47285 13.0432 2.42865 13.1376 2.42865 13.2361L2.42865 14.789C2.42865 14.9236 2.58334 14.9979 2.6878 14.9156L9.50008 9.58385L16.3124 14.9156C16.336 14.9341 16.3645 14.9456 16.3944 14.9488C16.4243 14.9519 16.4545 14.9466 16.4815 14.9334C16.5086 14.9202 16.5314 14.8996 16.5473 14.8741C16.5632 14.8486 16.5716 14.8191 16.5715 14.789L16.5715 13.2361C16.5715 13.1376 16.5253 13.0432 16.449 12.983L9.89785 7.85416C9.6628 7.67135 9.33736 7.67135 9.10432 7.85416ZM9.10432 3.79266L2.55119 8.92145C2.47285 8.98172 2.42865 9.07614 2.42865 9.17458L2.42865 10.7275C2.42865 10.8621 2.58334 10.9364 2.6878 10.854L9.50008 5.52235L16.3124 10.854C16.336 10.8726 16.3645 10.8841 16.3944 10.8873C16.4243 10.8904 16.4545 10.8851 16.4815 10.8719C16.5086 10.8587 16.5314 10.8381 16.5473 10.8126C16.5632 10.7871 16.5716 10.7576 16.5715 10.7275L16.5715 9.17458C16.5715 9.07614 16.5253 8.98172 16.449 8.92145L9.89785 3.79266C9.6628 3.60985 9.33736 3.60985 9.10432 3.79266Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgHighestKodemScore);
export { ForwardRef as ReactComponent };
